module.exports = __webpack_public_path__ + "static/media/lorry_10ft.793e6d14.svg";